import Cookies from 'js-cookie';

const Cookie = {
    init() {
        if (document.querySelector('.js-cookie')) {
            document.querySelector('.js-cookie-settings').addEventListener('click', this.showSettings.bind(this));
            const closeButtons = [...document.querySelectorAll('.js-cookie-close')];

            closeButtons.forEach(button => {
                button.addEventListener('click', this.close.bind(this));
            });

            if (Cookies.get('sweetsensationDefaultCookie')) {
                // this.exit();
            } else {
                this.initCookies();
            }
        }
    },

    showSettings(e) {
        e.preventDefault();
        document.querySelector('.cookies-settings').style.transform = 'translateY(-100%)';
        document.querySelector('.page-cookies').style.overflow = 'visible';
    },

    initCookies() {
        Cookies.set('sweetsensationDefaultCookie', 'true', { expires: 365 });
    },

    setCookies() {
        if (document.querySelector('.js-cookie-advanced').checked) {
            Cookies.set('sweetsensationAdvancedCookie', 'true', { expires: 365 });
        }

        if (window.dataLayer) {
            window.dataLayer.push({ event: 'cookie consent' });
        }
    },

    close() {
        this.setCookies();
        this.exit();
    },

    exit() {
        const elem = document.querySelector('.js-cookie');
        elem.parentNode.removeChild(elem);
    },
};

export default Cookie;
